import { render, staticRenderFns } from "./BeadRoad.vue?vue&type=template&id=66cf4b25&"
import script from "./BeadRoad.vue?vue&type=script&lang=js&"
export * from "./BeadRoad.vue?vue&type=script&lang=js&"
import style0 from "./BeadRoad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports